class deleteTemplate {
    constructor($injector) {
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');
        this.state = $injector.get('$state');
        this.stateParams = $injector.get('$stateParams');
        this.translate = $injector.get('$translate');

        this.back = this.stateParams.back;
        this.params = this.stateParams.backParams || {
            id: this.stateParams.id
        };

        this.key = 'delete-template';
        this.title = this.translate.instant('templates.workflows.details.delete-template.title');
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
    }

    /**
     * @todo translate and rework
     * @param template
     * @param vm
     */
    action(template, vm) {
        this.alert.confirm({
            title: `Deleting ${template.name}`,
            message: 'Are you sure you want to delete this template? This cannot be undone!',
            confirmBtn: 'Delete'
        }).then(() => {
            return this.api.delete(`templates/${template.id}`, {data: {force: true}})
                .then(() => {
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('deleteTemplate', [
        '$injector',
        ($injector) => new deleteTemplate($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/delete-template.js